import React, { useState } from "react";

export default function MiniCalendar({ onDateChange }) {
  const today = new Date();
  const [currentDate, setCurrentDate] = useState(today);
  const [selectedDate, setSelectedDate] = useState(today);
  
 

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const firstDayOfMonth = new Date(year, month, 1);
  const lastDayOfMonth = new Date(year, month + 1, 0);

  const startDay = (firstDayOfMonth.getDay() + 6) % 7; // Monday start
  const daysInMonth = lastDayOfMonth.getDate();
  
 


  function prevMonth() {
    setCurrentDate(new Date(year, month - 1, 1));
  }

  function nextMonth() {
    setCurrentDate(new Date(year, month + 1, 1));
  }

  function isSameDay(a, b) {
    return (
      a.getDate() === b.getDate() &&
      a.getMonth() === b.getMonth() &&
      a.getFullYear() === b.getFullYear()
    );
  }

  function handleDateClick(date) {
    setSelectedDate(date);

    if (onDateChange) {
      // Pass a NEW Date object to avoid reference equality issues
      onDateChange(new Date(date));
    }
  }

  const days = [];

  for (let i = 0; i < startDay; i++) {
    days.push(null);
  }

  for (let d = 1; d <= daysInMonth; d++) {
    days.push(new Date(year, month, d));
  }

  const styles = {
    container: {
      color: "#fff",
      fontSize: "13px"
    },

    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "8px"
    },

    month: {
      fontWeight: 600
    },

    nav: {
      cursor: "pointer",
      padding: "4px 8px",
      borderRadius: "6px",
      background: "rgba(255,255,255,0.1)"
    },

    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(7, 1fr)",
      gap: "4px"
    },

    dayHeader: {
      textAlign: "center",
      fontSize: "11px",
      opacity: 0.7
    },

    cell: {
      textAlign: "center",
      padding: "6px 0",
      borderRadius: "6px",
      cursor: "pointer"
    },

    selected: {
      background: "#ff9f1c",
      color: "#1f2b44",
      fontWeight: 600
    },

    today: {
      outline: "1px solid rgba(255,255,255,0.4)"
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.nav} onClick={prevMonth}>‹</div>
        <div style={styles.month}>
          {currentDate.toLocaleString("default", { month: "long" })} {year}
        </div>
        <div style={styles.nav} onClick={nextMonth}>›</div>
      </div>

      <div style={styles.grid}>
        {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(d => (
          <div key={d} style={styles.dayHeader}>{d}</div>
        ))}

        {days.map((date, i) => {
          if (!date) return <div key={i} />;

          const isSelected = isSameDay(date, selectedDate);
          const isToday = isSameDay(date, today);

          return (
            <div
              key={i}
              style={{
                ...styles.cell,
                ...(isSelected ? styles.selected : {}),
                ...(isToday && !isSelected ? styles.today : {})
              }}
              onClick={() => handleDateClick(date)}
            >
              {date.getDate()}
            </div>
          );
        })}
      </div>
    </div>
  );
}
